import React from "react";
import "./EditorialGallery.css";

function EditorialGallery(props) {
  const { className } = props;

  return (
    <div className={`editorial-gallery-2 border-1px-sonic-silver ${className || ""}`}>
      <div className="editorial poppins-medium-tundora-10px">EDITORIAL</div>
    </div>
  );
}

export default EditorialGallery;
